export default __webpack_public_path__ + "static/media/unforeseen-corners.c1c8a900.jpg";